import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import * as NavigationActions from "../../../actions/navigation";
import * as TrialInstitutionActions from "../../../actions/trialInstitution";
import * as TrialInstitutionContractActions from "../../../actions/trialInstitutionContract";
import { NotificationAlert } from "../../../components/common/index";
import {
    DatePickerFormInputFabric,
    TextFormInput,
} from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { isUrl } from "../../../functions/string";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    TrialInstitutionContractCreateBreadcrumbs,
    TrialInstitutionContractDetailsBreadcrumbs,
} from "../../../helpers/breadcrumbHelper";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import { TrialInstitutionContractSubMenu } from "../../../helpers/subMenuHelper";
import useNavigate from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { ITrialInstitutionContractReduxFormState } from "../../../reducers/reactReduxForms/trialInstitutionContract";

import "./TrialInstitutionContractPage.scss";

interface TrialInstitutionContractPageProps {
    form: Dtos.TrialInstitutionContract & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialInstitutionContractReduxFormState;
    trialInstitutionContract: Dtos.TrialInstitutionContract;
    lookups: Dtos.Lookup[];
    loadingTrialInstitutionContract: boolean;
    loadTrialInstitutionContractSuccess: boolean;
    loadTrialInstitutionContractFailure: boolean;
    loadTrialInstitutionContractErrorCode: string;
    savingTrialInstitutionContract: boolean;
    saveTrialInstitutionContractSuccess: boolean;
    saveTrialInstitutionContractFailure: boolean;
    creatingTrialInstitutionContract: boolean;
    createTrialInstitutionContractSuccess: boolean;
    createTrialInstitutionContractFailure: boolean;
    validatingTrialInstitutionContract: boolean;
    validationFailures: Dtos.ResponseError[];
    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    trialInstitution: Dtos.TrialInstitution;
    loadingTrialInstitution: boolean;
    loadTrialInstitutionSuccess: boolean;
    loadTrialInstitutionFailure: boolean;
    loadTrialInstitutionErrorCode: string;
    clearTrialInstitutionContract: TrialInstitutionContractActions.ITrialInstitutionContractClearActionCreator;
    loadTrialInstitutionContract: TrialInstitutionContractActions.ITrialInstitutionContractLoadByIdActionCreator;
    saveTrialInstitutionContract: TrialInstitutionContractActions.ITrialInstitutionContractSaveActionCreator;
    createTrialInstitutionContract: TrialInstitutionContractActions.ITrialInstitutionContractCreateActionCreator;
    validateTrialInstitutionContract: TrialInstitutionContractActions.ITrialInstitutionContractValidateActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
    loadTrialInstitution: TrialInstitutionActions.ITrialInstitutionLoadByIdActionCreator;
    clearTrialInstitution: TrialInstitutionActions.ITrialInstitutionClearActionCreator;
}

const reduxFormName: string = "reduxForms.trialInstitutionContract";

const TrialInstitutionContractPage: FC<TrialInstitutionContractPageProps> = ({
    form,
    formState,
    formProperties,
    trialInstitutionContract,
    lookups,
    loadingTrialInstitutionContract,
    loadTrialInstitutionContractFailure,
    loadTrialInstitutionContractErrorCode,
    savingTrialInstitutionContract,
    saveTrialInstitutionContractSuccess,
    saveTrialInstitutionContractFailure,
    creatingTrialInstitutionContract,
    validatingTrialInstitutionContract,
    validationFailures,
    permissions,
    trialInstitution,
    loadingTrialInstitution,
    loadTrialInstitutionFailure,
    loadTrialInstitutionErrorCode,
    clearTrialInstitutionContract,
    loadTrialInstitutionContract,
    saveTrialInstitutionContract,
    createTrialInstitutionContract,
    validateTrialInstitutionContract,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems,
    loadTrialInstitution,
    clearTrialInstitution
}) => {
    //
    // -- Params --
    const { trialId } = useParams<{ trialId: string }>();
    const { trialInstitutionId } = useParams<{ trialInstitutionId: string }>();
    const { trialInstitutionContractId } = useParams<{trialInstitutionContractId: string;}>();
    const trialIdNumber = parseInt(trialId, 10);
    const trialInstitutionIdNumber = parseInt(trialInstitutionId, 10);
    const trialInstitutionContractIdNumber = parseInt(trialInstitutionContractId, 10);

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [formInitalised, setFormInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    //
    // -- Hooks --
    const navigate = useNavigate();

    const loadReduxForm = () => {
        let extraData: Dtos.TrialInstitutionContract = {} as Dtos.TrialInstitutionContract;

        loadForm(
            reduxFormName,
            Object.assign({ ...trialInstitutionContract }, extraData)
        );
    };


    // Load Trial Institution & Contract
    useEffect(() => {
        if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionContractIdNumber &&
            !trialInstitutionContract
        ) {
            setBreadcrumbs(
                TrialInstitutionContractDetailsBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionContractIdNumber
                )
            );

            loadTrialInstitutionContract(trialInstitutionContractIdNumber);
        } else if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            !trialInstitutionContractIdNumber &&
            !trialInstitutionContract
        ) {
            setBreadcrumbs(
                TrialInstitutionContractCreateBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber
                )
            );
            setDrawerItems([]);
            createTrialInstitutionContract(trialInstitutionIdNumber);
        } else if (trialInstitutionContract && !formInitalised) {
            loadReduxForm();
            setFormInitalised(true);
        }

        if (
            trialInstitutionIdNumber &&
            !trialInstitution &&
            !loadingTrialInstitution
        ) {
            loadTrialInstitution(trialInstitutionIdNumber);
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionContractIdNumber,
        trialInstitutionContract,
        formInitalised,
        setDrawerItems,
        setBreadcrumbs,
        loadTrialInstitutionContract,
        trialInstitution,
        loadTrialInstitution,
        setFormInitalised,
        TrialInstitutionContractDetailsBreadcrumbs,
        TrialInstitutionContractCreateBreadcrumbs,
        createTrialInstitutionContract,
        loadReduxForm,
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadTrialInstitutionContractFailure) {
            navigate(`/error/${loadTrialInstitutionContractErrorCode}`);
        }
        if (loadTrialInstitutionFailure) {
            navigate(`/error/${loadTrialInstitutionErrorCode}`);
        }
    }, [
        loadTrialInstitutionContractFailure,
        loadTrialInstitutionFailure,
        loadTrialInstitutionContractErrorCode,
        loadTrialInstitutionErrorCode,
        navigate,
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionContractIdNumber &&
            trialInstitutionContract &&
            trialInstitution
        ) {
            setDrawerItems(
                TrialInstitutionContractSubMenu(
                    trialInstitutionContract,
                    permissions
                )
            );
            setBreadcrumbs(
                TrialInstitutionContractDetailsBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionContractIdNumber,
                    trialInstitution?.trial?.displayName,
                    trialInstitution?.institution?.name,
                    trialInstitutionContract?.name
                )
            );
        } else if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            !trialInstitutionContractIdNumber &&
            trialInstitution
        ) {
            setBreadcrumbs(
                TrialInstitutionContractCreateBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitution?.trial?.displayName,
                    trialInstitution?.institution?.name
                )
            );
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionContractIdNumber,
        trialInstitutionContract,
        trialInstitution,
        permissions,
        setDrawerItems,
        setBreadcrumbs,
        TrialInstitutionContractDetailsBreadcrumbs,
        TrialInstitutionContractCreateBreadcrumbs,
        TrialInstitutionContractSubMenu,
    ]);

    // Reload trial institution contract after saving
    useEffect(() => {
        if (
            !savingTrialInstitutionContract &&
            saveTrialInstitutionContractSuccess
        ) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Trial Institution Contract saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(`/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/contracts`);
            } else if (!trialInstitutionContractIdNumber) {
                navigate(`/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/contracts/${trialInstitutionContract?.id}/details`);
                clearTrialInstitutionContract();
            } else {
                loadTrialInstitutionContract(trialInstitutionContractIdNumber);
            }
        }
    }, [
        savingTrialInstitutionContract,
        saveTrialInstitutionContractSuccess,
        loadTrialInstitutionContract,
        trialInstitutionContractIdNumber,
        navigate,
        saveAndReturn,
        clearTrialInstitutionContract,
    ]);

    // Failed saving
    useEffect(() => {
        if (
            !savingTrialInstitutionContract &&
            saveTrialInstitutionContractFailure
        ) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [
        savingTrialInstitutionContract,
        saveTrialInstitutionContractSuccess,
        loadTrialInstitutionContract,
        trialInstitutionContractIdNumber,
    ]);

    // Cleanup effect to clear the trial institution & contract on component unmount
    useEffect(() => {
        return () => {
            clearTrialInstitutionContract();
            clearTrialInstitution();
            resetForm(reduxFormName);
        };
    }, [
        clearTrialInstitutionContract,
        clearTrialInstitution,
        resetForm,
        reduxFormName,
    ]);

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.TrialInstitutionContract = {} as Dtos.TrialInstitutionContract;

            if (!data.trialInstitutionId) {
                changes.trialInstitutionId = trialInstitutionIdNumber;
            }

            await saveTrialInstitutionContract(
                Object.assign({ ...data }, changes)
            );

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    const handleOnSubmitFailed = (_data: Dtos.TrialInstitutionContract) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const onCancel = () => {
        navigate(`/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/contracts`);
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.TrialInstitutionContract = {} as Dtos.TrialInstitutionContract;

            if (
                form &&
                hasBeenSubmitted &&
                !validatingTrialInstitutionContract
            ) {
                await validateTrialInstitutionContract(
                    Object.assign({ ...form }, changes)
                );
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const openLink = (link: string) => {
        window.open(`${link}`, "_blank");
        return null;
    };

    const renderContent = useMemo(() => {
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermissionFor(
                undefined,
                trialInstitutionContractIdNumber,
                permissions,
                Dtos.Permission.TrialInstitutionContractUpdate,
                Dtos.Permission.TrialInstitutionContractCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingTrialInstitutionContract ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionContract",
                                        {
                                            name: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-12 col-xl-2",
                                                fieldClassName: "col-sm-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionContract",
                                        {
                                            location: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    addOnRightButton: (
                                                        <button
                                                            className="btn btn-secondary"
                                                            type="button"
                                                            id="button-addon2"
                                                            disabled={form?.location == null || !isUrl(form?.location)}
                                                            style={{
                                                                cursor: form?.location == null || !isUrl(form?.location)
                                                                        ? "not-allowed"
                                                                        : "pointer",
                                                                padding: "4px 10px",
                                                            }}
                                                            onClick={() => {
                                                                openLink(form.location);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={FontAwesomeIcons.Duotone.ARROWUPRIGHTFROMSQUARE} />
                                                        </button>
                                                    ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-12 col-xl-2",
                                                fieldClassName: "col-sm-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionContract",
                                        {
                                            dateSentToSite: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-12 col-xl-4",
                                                fieldClassName: "col-sm-12 col-xl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionContract",
                                        {
                                            dateConfirmedBySite: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-12 col-xl-4",
                                                fieldClassName: "col-sm-12 col-xl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Details</h1>
                    </div>
                    <div
                        className="col d-flex justify-content-end align-items-stretch"
                        style={{ height: "38px" }}
                    >
                        {/* {(AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabView) && trialInstitutionContractIdNumber) ? (
                            <Link 
                                className={"btn btn-primary"} 
                                url={`/labs/${trialInstitutionContract?.laboratoryId}/details`}
                                target='_blank'
                            >
                                {`Primary  `}
                                <FontAwesomeIcon icon={FontAwesomeIcons.Duotone.ARROWUPRIGHTFROMSQUARE} />
                            </Link>
                        ) : null} */}
                    </div>
                </div>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => handleOnSubmit(val)}
                    onSubmitFailed={(val) => handleOnSubmitFailed(val)}
                >
                    {renderFormControls(
                        form,
                        "trialInstitutionContract",
                        formComponents,
                        lookups,
                        validationFailures,
                        formProperties,
                        changeForm
                    )}
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(reduxFormName + ".saveAndReturn", false);
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(reduxFormName + ".saveAndReturn", true);
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={onCancel}
                            className="btn btn-primary mr-2"
                        >
                            Cancel
                        </button>
                    </div>
                </Form>
            </>
        );
    }, [
        AuthenticationHelper,
        trialInstitutionContractIdNumber,
        permissions,
        savingTrialInstitutionContract,
        formState,
        handleOnSubmit,
        handleOnSubmitFailed,
        renderFormControls,
        lookups,
        validationFailures,
        formProperties,
        form,
        changeForm,
        reduxFormName,
        onCancel,
        trialInstitution,
        trialInstitutionContract,
    ]);

    return (
        <RestrictedLayout
            permission={Dtos.Permission.TrialInstitutionContractView}
            loading={
                loadingTrialInstitutionContract ||
                creatingTrialInstitutionContract ||
                savingTrialInstitutionContract
            }
        >
            {renderContent}
        </RestrictedLayout>
    );
};

const mapStateToProps = (
    state: ITmdState
): Partial<TrialInstitutionContractPageProps> => {
    let trialInstitutionContract: Dtos.TrialInstitutionContract | undefined = !(
        state.trialInstitutionContract.formData instanceof Array
    )
        ? state.trialInstitutionContract.formData
        : undefined;
    let trialInstitution: Dtos.TrialInstitution | undefined = !(
        state.trialInstitution.formData instanceof Array
    )
        ? state.trialInstitution.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        trialInstitutionContract: trialInstitutionContract!,
        loadingTrialInstitutionContract: state.trialInstitutionContract.loadState && state.trialInstitutionContract.loadState.status == RequestState.Pending,
        loadTrialInstitutionContractSuccess: state.trialInstitutionContract.loadState && state.trialInstitutionContract.loadState.status == RequestState.Success,
        loadTrialInstitutionContractFailure: state.trialInstitutionContract.loadState && state.trialInstitutionContract.loadState.status == RequestState.Failure,
        loadTrialInstitutionContractErrorCode: state.trialInstitutionContract.loadState.errorCode,
        savingTrialInstitutionContract: state.trialInstitutionContract.saveState && state.trialInstitutionContract.saveState.status == RequestState.Pending,
        saveTrialInstitutionContractSuccess: state.trialInstitutionContract.saveState && state.trialInstitutionContract.saveState.status == RequestState.Success,
        saveTrialInstitutionContractFailure: state.trialInstitutionContract.saveState && state.trialInstitutionContract.saveState.status == RequestState.Failure,
        creatingTrialInstitutionContract: state.trialInstitutionContract.createState && state.trialInstitutionContract.createState.status == RequestState.Pending,
        createTrialInstitutionContractSuccess: state.trialInstitutionContract.createState && state.trialInstitutionContract.createState.status == RequestState.Success,
        createTrialInstitutionContractFailure: state.trialInstitutionContract.createState && state.trialInstitutionContract.createState.status == RequestState.Failure,
        validatingTrialInstitutionContract: state.trialInstitutionContract.validateState && state.trialInstitutionContract.validateState.status == RequestState.Pending,
        user: state.user.data,
        permissions: permissions,
        lookups: state.trialInstitutionContract.lookups,
        form: state.reduxForms.trialInstitutionContract,
        formState: state.trialInstitutionContract.formState,
        formProperties: state.trialInstitutionContract.formProperties,
        reduxFormState: state.reduxForms.formState.trialInstitutionContract,
        validationFailures: trialInstitutionContract
            ? state.trialInstitutionContract.validationFailures
            : undefined,
        trialInstitution: trialInstitution!,
        loadingTrialInstitution: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Pending,
        loadTrialInstitutionSuccess: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Success,
        loadTrialInstitutionFailure: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Failure,
        loadTrialInstitutionErrorCode: state.trialInstitution.loadState.errorCode,
    };
};

const mapDispatchToProps = (
    dispatch
): Partial<TrialInstitutionContractPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadTrialInstitutionContract: bindActionCreators(TrialInstitutionContractActions.LoadTrialInstitutionContractById, dispatch),
        clearTrialInstitutionContract: bindActionCreators(TrialInstitutionContractActions.Clear, dispatch),
        saveTrialInstitutionContract: bindActionCreators(TrialInstitutionContractActions.SaveTrialInstitutionContract, dispatch),
        createTrialInstitutionContract: bindActionCreators(TrialInstitutionContractActions.CreateTrialInstitutionContract, dispatch),
        validateTrialInstitutionContract: bindActionCreators(TrialInstitutionContractActions.ValidateTrialInstitutionContract, dispatch),
        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch),
        loadTrialInstitution: bindActionCreators(TrialInstitutionActions.LoadTrialInstitutionById, dispatch),
        clearTrialInstitution: bindActionCreators(TrialInstitutionActions.Clear, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrialInstitutionContractPage);
